import React, { useState } from 'react';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { CourtConfirmation } from './CourtConfirmation';
import { useActiveMatter } from '../../lib/activeMatter';

export const MatterCourtConfirmation = ({ matter, onUpdated }) => {
  const { api } = useAuth();
  const [active, setActive] = useActiveMatter();
  const [open, setOpen] = useState(!!matter.court_review);
  const [review, setReview] = useState(matter.court_review);
  const [value, setValue] = useState({ court_name: matter.court || '', court_slug: matter.court_slug || '', region: matter.region || '' });
  const [dirty, setDirty] = useState(false);
  const [busy, setBusy] = useState(false);
  const confirmed = !dirty && review?.status === 'confirmed' && review?.selected_name === value.court_name && review?.selected_slug === (value.court_slug || null);
  const load = async () => {
    setBusy(true);
    try { const r = await api.get(`/crm/matters/${matter.id}/court-confirmation`); setReview(r.data); setOpen(true); }
    catch { toast.error('No se pudo recuperar la cita del documento'); } finally { setBusy(false); }
  };
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.put(`/crm/matters/${matter.id}/court-confirmation`, { ...value, court_slug: value.court_slug || null });
      setReview(r.data); setDirty(false);
      if (active?.id === matter.id) setActive((await api.get(`/crm/matters/${matter.id}`)).data.matter);
      onUpdated(); toast.success('Corte confirmada y guardada en el caso');
    } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo confirmar la corte'); } finally { setBusy(false); }
  };
  if (!open) return <button type="button" data-testid={`matter-court-review-${matter.id}`} onClick={load} disabled={busy} className="mt-2 break-words text-left text-xs text-sky-300 hover:text-sky-100">{busy ? 'Buscando la cita…' : `${matter.court || 'Corte sin indicar'} · Revisar y confirmar`}</button>;
  return <CourtConfirmation testid={`court-confirmation-${matter.id}`} value={value} review={review} confirmed={confirmed} busy={busy} onChange={(v) => { setValue(v); setDirty(true); }} onConfirm={save} />;
};